// extracted by mini-css-extract-plugin
export default {"root":"CustomerModule_root__F2rDq","drawer":"CustomerModule_drawer__qleTb","app-content":"CustomerModule_app-content__X6Yyv"};